/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'
import footer from "../../components/footer";



function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
  },
  view({ state, attrs }) {
    // console.log({t:t()})
    return [
      // <!--begin::Header-->
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: "/support"
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: "/notifications"
        }, {
          label: t().home_acc_info.navbar.trends,
          route: "/trends-disabled"
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            // <!--begin::Toolbar-->
            m(toolbar, {
              header: {
                label: "XYZ Transporters",
                subLabel: [t().common.account_type, t().common.post_paid]
              },
              toolBarItems: [{
                label: t().home_acc_info.subheader_labels.dashboard,
                route: "/dashboard",
                routesToActivate: ["/dashboard"]
              }, {
                label: t().home_acc_info.subheader_labels.home,
                route: "/",
                routesToActivate: ["/", "/stationFinder", "/journeyPlan"]
              }, {
                label: t().home_acc_info.subheader_labels.cards,
                route: "/cardList",
                routesToActivate: ["/cardList", "/departments", "/drivers"]
              }, {
                label: t().home_acc_info.subheader_labels.transactions,
                route: "/transactions",
                routesToActivate: ["/transactions"]
              }, {
                label: t().home_acc_info.subheader_labels.funds,
                route: "/funds",
                routesToActivate: ["/funds", "/cardToCard"]
              }]
            }),
            // <!--end::Toolbar-->

            // <!--begin::Content-->
            m("div", { "class": "app-container", "id": "kt_app_content_container", style: { margin: '30px' } }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row row" }, [
                // cards here
                [{
                  label: t().reports.report_types.transaction_report,
                  icon: `<svg width="87" height="90" viewBox="0 0 87 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M78.0833 2H8.91667C7.08225 2 5.32297 2.75506 4.02585 4.09907C2.72872 5.44308 2 7.26595 2 9.16667V80.8333C2 82.734 2.72872 84.5569 4.02585 85.9009C5.32297 87.2449 7.08225 88 8.91667 88H78.0833C79.9177 88 81.677 87.2449 82.9742 85.9009C84.2713 84.5569 85 82.734 85 80.8333V9.16667C85 7.26595 84.2713 5.44308 82.9742 4.09907C81.677 2.75506 79.9177 2 78.0833 2Z" stroke="#E2E8F0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M36.5842 61.7222L48.112 71.2778L66.5564 47.3889M20.4453 23.5H66.5564M20.4453 42.6111H38.8898" stroke="#E2E8F0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  `
                }, {
                  label: t().reports.report_types.invoice_report,
                  icon: `<svg width="103" height="101" viewBox="0 0 103 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M87.9788 29.4583L51.4997 8.41667L15.0205 29.4583V71.5417L51.4997 92.5833L87.9788 71.5417V29.4583Z" stroke="#E2E8F0" stroke-width="4" stroke-linejoin="round"/>
                  <path d="M51.4997 46.2917V63.125M68.6663 37.875V63.125M34.333 54.7083V63.125" stroke="#E2E8F0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  `
                }, {
                  label: t().reports.report_types.topup_report,
                  icon: `<svg width="112" height="91" viewBox="0 0 112 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M46.0231 20.8021H45.807C37.052 20.8021 30.1929 20.8021 24.8391 21.38C19.3639 21.9701 15.0414 23.205 11.6479 25.9242C8.25432 28.6465 6.7187 32.114 5.98311 36.5092C5.2627 40.801 5.2627 46.3034 5.2627 53.3266V53.6734C5.2627 60.6966 5.2627 66.199 5.98311 70.4938C6.7187 74.886 8.25811 78.3535 11.6479 81.0757C15.0414 83.798 19.3639 85.0299 24.8429 85.62C30.1929 86.1979 37.052 86.1979 45.807 86.1979H46.2392C54.9942 86.1979 61.8533 86.1979 67.2072 85.62C72.6823 85.0299 77.0048 83.795 80.3984 81.0757C83.7919 78.3535 85.3275 74.886 86.0631 70.4907C86.7835 66.199 86.7835 60.6966 86.7835 53.6734V53.5C86.7835 52.895 86.4839 52.3147 85.9506 51.8869C85.4173 51.4591 84.694 51.2187 83.9398 51.2187C83.1856 51.2187 82.4622 51.4591 81.9289 51.8869C81.3956 52.3147 81.096 52.895 81.096 53.5C81.096 60.7331 81.0884 65.9282 80.4287 69.8824C79.7765 73.7727 78.5329 76.1178 76.3754 77.8516C74.2141 79.5823 71.2946 80.5769 66.445 81.1001C61.5159 81.6293 55.0397 81.6354 46.0231 81.6354C37.0065 81.6354 30.5304 81.6293 25.6012 81.1001C20.7517 80.5769 17.8283 79.5792 15.667 77.8485C13.5096 76.1148 12.2697 73.7727 11.6175 69.8824C10.9578 65.9282 10.9502 60.7331 10.9502 53.5C10.9502 46.2669 10.9578 41.0717 11.6175 37.1176C12.2697 33.2273 13.5134 30.8822 15.6708 29.1484C17.8321 27.4177 20.7517 26.4231 25.6012 25.8999C30.5304 25.3707 37.0065 25.3646 46.0231 25.3646C46.7773 25.3646 47.5006 25.1242 48.0339 24.6964C48.5673 24.2686 48.8669 23.6884 48.8669 23.0833C48.8669 22.4783 48.5673 21.8981 48.0339 21.4702C47.5006 21.0424 46.7773 20.8021 46.0231 20.8021Z" fill="#E2E8F0"/>
                  <path d="M82.158 27.7371C82.6603 27.3046 82.9338 26.7327 82.9208 26.1417C82.9078 25.5507 82.6094 24.9868 82.0883 24.5688C81.5673 24.1508 80.8644 23.9114 80.1277 23.901C79.3909 23.8906 78.6779 24.11 78.1389 24.5129L48.8672 47.9946V37.2423C48.8672 36.6373 48.5676 36.057 48.0343 35.6292C47.501 35.2014 46.7776 34.961 46.0234 34.961C45.2692 34.961 44.5459 35.2014 44.0126 35.6292C43.4793 36.057 43.1797 36.6373 43.1797 37.2423V53.5C43.1797 54.7592 44.4537 55.7812 46.0234 55.7812H66.2861C67.0403 55.7812 67.7636 55.5409 68.2969 55.1131C68.8302 54.6853 69.1299 54.105 69.1299 53.5C69.1299 52.895 68.8302 52.3147 68.2969 51.8869C67.7636 51.4591 67.0403 51.2187 66.2861 51.2187H52.8864L82.158 27.7371Z" fill="#E2E8F0"/>
                  </svg>
                  `
                }].map(({ label, amount, icon }) => {
                  return m("div", {
                    "class": "col pe-2 ps-2 pb-2 pt-2",
                    "style": {
                      "cursor": "pointer"
                    }
                  },
                    m("div", {
                      "class": "card card-flush h-md-100", style: {
                        // boxShadow: "0px 0px 10px rgba(0,0,0,0.5)"
                      }
                    },
                      m("div", {
                        "class": "card-header pt-5 mb-6", style: {
                          margin: "30px"
                        }
                      },
                        m("h3", { "class": "card-title align-items-start flex-column" },
                          [
                            m("span", { "class": "fs-2hx fw-bold text-gray-800", style: "font-size: 2.0rem !important;" },
                              m("b", label)
                            ),
                            

                          ]
                        ),
                        m("h3", {
                          "class": "card-title align-items-start flex-column", "style": {
                            // transform: "translateY(-20px)"
                          }
                        },
                          [
                            m("div", { "class": "d-flex align-items-center mb-2" },
                              [

                                m("span", { "class": "fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2" },
                                  m.trust(icon)),
                              ]
                            ),

                          ]
                        )
                      )
                    )
                  )
                })
                // <!--end::Content-->
              ]),
              m("div", { "class": "d-flex flex-column flex-lg-row row" }, [
                // cards here
                [{
                  label: t().reports.report_types.audit_trail_report,
                  icon: `<svg width="111" height="91" viewBox="0 0 111 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M88.4326 18.5121L55.4956 17.8998L22.5585 18.5121C16.4552 18.6256 11.2875 22.2457 10.184 27.1808C7.5168 39.1086 7.5168 51.336 10.184 63.2637C11.2875 68.1988 16.4552 71.8189 22.5585 71.9324L55.4956 72.5447L88.4326 71.9324C94.536 71.8189 99.7037 68.1988 100.807 63.2637C103.474 51.336 103.474 39.1086 100.807 27.1808C99.7037 22.2457 94.5359 18.6256 88.4326 18.5121ZM22.7141 24.1635L55.4956 23.554L88.2771 24.1635C91.121 24.2163 93.5289 25.9031 94.0431 28.2026C94.7458 31.3455 95.2523 34.5105 95.5625 37.6852H15.4286C15.7388 34.5105 16.2453 31.3455 16.9481 28.2026C17.4623 25.9031 19.8702 24.2163 22.7141 24.1635ZM15.061 45.2222C15.061 50.919 15.6901 56.6158 16.9481 62.2419C17.4623 64.5414 19.8702 66.2282 22.7141 66.2811L55.4956 66.8905L88.2771 66.2811C91.121 66.2282 93.5289 64.5414 94.0431 62.2419C95.3011 56.6158 95.9301 50.919 95.9301 45.2222H15.061Z" fill="#E2E8F0"/>
                  </svg>
                  `
                }, {
                  label: t().reports.report_types.card_list_report,
                  icon: `<svg width="76" height="70" viewBox="0 0 76 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M38.334 43.75C37.9876 44.4336 37.7279 45.14 37.5547 45.8691C37.3815 46.5983 37.2207 47.3503 37.0723 48.125H14.25V43.75H38.334ZM14.25 56.875V52.5H36.998C37.1217 53.252 37.2949 53.9925 37.5176 54.7217C37.7402 55.4508 38.0247 56.1686 38.3711 56.875H14.25ZM9.5 65.625H59.5605L64.2734 70H4.75V0H46.127L66.5 18.7646V38.1787C65.7826 37.5863 65.028 37.0508 64.2363 36.5723C63.4447 36.0938 62.6159 35.6722 61.75 35.3076V21.875H42.75V4.375H9.5V65.625ZM47.5 7.48535V17.5H58.373L47.5 7.48535ZM48.3906 35C45.694 35.9342 43.3809 37.3926 41.4512 39.375H14.25V35H48.3906ZM14.25 17.5H38V21.875H14.25V17.5ZM57 26.25V30.625H14.25V26.25H57ZM76 67.8125C76 68.4049 75.765 68.9176 75.2949 69.3506C74.8249 69.7835 74.2682 70 73.625 70C72.9818 70 72.4251 69.7835 71.9551 69.3506L61.1562 59.4385C60.1914 60.0309 59.1523 60.4753 58.0391 60.7715C56.9258 61.0677 55.7878 61.2272 54.625 61.25C52.9922 61.25 51.4583 60.9652 50.0234 60.3955C48.5885 59.8258 47.3268 59.0511 46.2383 58.0713C45.1497 57.0915 44.2962 55.9294 43.6777 54.585C43.0592 53.2406 42.75 51.8164 42.75 50.3125C42.75 48.8086 43.0592 47.3958 43.6777 46.0742C44.2962 44.7526 45.1374 43.6019 46.2012 42.6221C47.265 41.6423 48.5267 40.8561 49.9863 40.2637C51.446 39.6712 52.9922 39.375 54.625 39.375C56.2578 39.375 57.7917 39.6598 59.2266 40.2295C60.6615 40.7992 61.9108 41.5853 62.9746 42.5879C64.0384 43.5905 64.8919 44.7526 65.5352 46.0742C66.1784 47.3958 66.5 48.8086 66.5 50.3125C66.5 51.3835 66.3392 52.4316 66.0176 53.457C65.696 54.4824 65.2012 55.4395 64.5332 56.3281L75.2949 66.2744C75.765 66.7074 76 67.2201 76 67.8125ZM47.5 50.3125C47.5 51.224 47.6855 52.0784 48.0566 52.876C48.4277 53.6735 48.9349 54.3685 49.5781 54.9609C50.2214 55.5534 50.9759 56.0205 51.8418 56.3623C52.7077 56.7041 53.6354 56.875 54.625 56.875C55.6146 56.875 56.5423 56.7041 57.4082 56.3623C58.2741 56.0205 59.0286 55.5534 59.6719 54.9609C60.3151 54.3685 60.8223 53.6735 61.1934 52.876C61.5645 52.0784 61.75 51.224 61.75 50.3125C61.75 49.401 61.5645 48.5466 61.1934 47.749C60.8223 46.9515 60.3151 46.2565 59.6719 45.6641C59.0286 45.0716 58.2741 44.6045 57.4082 44.2627C56.5423 43.9209 55.6146 43.75 54.625 43.75C53.6354 43.75 52.7077 43.9209 51.8418 44.2627C50.9759 44.6045 50.2214 45.0716 49.5781 45.6641C48.9349 46.2565 48.4277 46.9515 48.0566 47.749C47.6855 48.5466 47.5 49.401 47.5 50.3125Z" fill="#CBD5E1"/>
                  </svg>
                  `
                }, {
                  label: t().reports.report_types.anomaly_report,
                  icon: `<svg width="85" height="89" viewBox="0 0 85 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.2497 11.125H63.7497V18.5417H77.9163V70.4583H63.7497V77.875H21.2497V70.4583H7.08301V18.5417H21.2497V11.125ZM21.2497 25.9583H14.1663V63.0417H21.2497V25.9583ZM28.333 70.4583H56.6663V18.5417H28.333V70.4583ZM63.7497 25.9583V63.0417H70.833V25.9583H63.7497Z" fill="#CBD5E1"/>
                  </svg>
                  `
                }].map(({ label, amount, icon }) => {
                  return m("div", {
                    "class": "col pe-2 ps-2 pb-2 pt-2",
                    "style": {
                      "cursor": "pointer"
                    }
                  },
                    m("div", {
                      "class": "card card-flush h-md-100", style: {
                        // boxShadow: "0px 0px 10px rgba(0,0,0,0.5)"
                      }
                    },
                      m("div", { "class": "card-header pt-5 mb-6", style: {
                        margin: "30px"
                      } },
                        m("h3", { "class": "card-title align-items-start flex-column" },
                          [
                            m("span", { 
                              "class": "fw-bold text-gray-800", 
                              "style": "font-size: 2.0rem !important;" 
                            },
                              m("b", label)
                            ),
                            

                          ]
                        ),
                        m("h3", {
                          "class": "card-title align-items-start flex-column", "style": {
                            // transform: "translateY(-20px)"
                          }
                        },
                          [
                            m("div", { "class": "d-flex align-items-center mb-2" },
                              [

                                m("span", { "class": "fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2" },
                                  m.trust(icon)),
                              ]
                            ),

                          ]
                        )
                      )
                    )
                  )
                })
                // <!--end::Content-->
              ]),

              // <!--end::Inbox App - Messages -->
            ])
            // <!--end::Content-->
          ]),
          m(footer)
        ])
      ])

    ];
  }
};